// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchBeginLoadWishListLines,
    DispatchCompleteLoadWishListLines,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

/**
 * XNG-Changes:
 * Stop flush message
 * https://xngage.atlassian.net/browse/PLS-1095
 */
export const DispatchLoadingWishListLines: typeof DispatchBeginLoadWishListLines = props => {
    props.dispatch({
        type: "xWishListLines/isLoading",
        isLoading: true,
    } as any);
};

export const DispatchLoadedWishListLines: typeof DispatchCompleteLoadWishListLines = props => {
    props.dispatch({
        type: "xWishListLines/isLoading",
        isLoading: false,
    } as any);
};

addToChainBefore(chain, DispatchBeginLoadWishListLines, DispatchLoadingWishListLines);
addToChainAfter(chain, DispatchCompleteLoadWishListLines, DispatchLoadedWishListLines);
